import React from "react";

import styles from "./ruby-timeline.module.css";

export const RubyMarker: React.FC = () => (
  <svg
    viewBox="-1 -1 136 117"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    stroke="var(--primary-color)"
    className={styles.marker}
  >
    <path fill="none" strokeWidth="6" d="M24.25,0.22 L0.45,46.33 L67.08,114.41 L133.71,46.33 L109.47,0.22 Z" />
    <g fill="none" strokeWidth="3">
      <path d="M0.45,46.33 L133.71,46.33" />
      <path d="M24.25,0.22 L37.23,46.33 L67.08,0.22 L96.93,46.33 L109.47,0.22" />
      <path d="M37.23,46.33 L67.08,114.41 L96.93,46.33 L67.08,0.22" />
    </g>
  </svg>
);

export const RubyTimeline: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.timeline} data-react-timeline>
    {children}
  </div>
);

export const RubyTooltip: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.tooltip}>
    <div className={styles.toolbody}>
      {children}
    </div>
  </div>
);
